export default "__VITE_ASSET__DYV3Nl5V__"